import {title} from './data'
import './Header.css'


export default function Header() {
  return <>
    <div className="header">
      {title}
    </div>
  </>
}